export default __webpack_public_path__ + "static/media/18.94e836a6.png";